import { Row, Col, Button } from 'react-bootstrap';
import { useSelector } from "react-redux";
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import AgendaItemCard from './AgendaItemCard';
import AgendaItemAddNewModal from './crudModals/AgendaItemAddNewModal';
import { Spinner } from 'react-bootstrap';
import noSleep from 'nosleep.js';
// const date = require('date-and-time');

export default function AgendaComponent({ meeting, getMeeting, isLoading }) {
  const { user: authUser } = useSelector(x => x.auth);
  const url = process.env.REACT_APP_URL
  const params = useParams();
  const meetingId = params.meetingId;
  const agenda = meeting.items;

  let myNoSleep = new noSleep();

  const [isNoSleep, setIsNoSleep] = useState(false);
  const [toggleText, setToggleText] = useState('Keep Screen On');
  const [toggleColor, setToggleColor] = useState('primary');
  const [agendaWithStartTimes, setAgendaWithStartTimes] = useState([]);

  useEffect(() => {
    if (isNoSleep) { myNoSleep.enable(); } else { myNoSleep.disable(); }
    // eslint-disable-next-line
  }, [isNoSleep]);

  useEffect(() => {
    if (agenda?.length > 0) {
      const meetingTime = meeting.meetingDetails.meetingTime;
      const meetingTheme = meeting.meetingDetails.meetingTheme; // Extract meetingTheme
      setAgendaWithStartTimes(calculateStartTime(meetingTime, agenda, meetingTheme));
    }
  }, [agenda, meeting]);

  const toggleWakeOnScreen = (e) => {
    e.preventDefault();
    setIsNoSleep(!isNoSleep);
    isNoSleep ? setToggleText('Keep Screen On') : setToggleText('Allow screen off');
    isNoSleep ? setToggleColor('primary') : setToggleColor('danger');
    if (toggleColor === 'danger') { window.location.reload(false); }
  };

  const calculateStartTime = (meetingTime, agenda, meetingTheme) => {
    let startTime = meetingTime; // Initialize with the meeting's start time (e.g., "18:30")
    return agenda.map((agendaItem, index) => {
      if (index === 0) {
        // The first item starts at the meeting's start time
        return { ...agendaItem, startTime: meetingTime, meetingTheme }; // Add meetingTheme
      } else {
        // Calculate the start time for subsequent items
        const previousItem = agenda[index - 1];
        const previousDuration = previousItem.agendaEvent?.total || "00:00"; // Default to "00:00" if no duration
        const [addedMinutes, addedSeconds] = previousDuration.split(':').map(Number);

        // Parse the current start time (HH:mm)
        const [currentHours, currentMinutes] = startTime.split(':').map(Number);

        // Create a new Date object to handle time calculations
        const newStartTime = new Date();
        newStartTime.setHours(currentHours);
        newStartTime.setMinutes(currentMinutes + addedMinutes); // Add minutes
        newStartTime.setSeconds(addedSeconds || 0); // Add seconds (default to 0 if not provided)

        // Format the new start time as "HH:mm"
        const formattedStartTime = `${String(newStartTime.getHours()).padStart(2, '0')}:${String(newStartTime.getMinutes()).padStart(2, '0')}`;
        startTime = formattedStartTime; // Update the start time for the next item

        return { ...agendaItem, startTime: formattedStartTime, meetingTheme }; // Add meetingTheme
      }
    });
  };

  const onDragEnd = async (result) => {
    const { source, destination } = result;

    // If dropped outside the list or no change in position
    if (!destination || source.index === destination.index) {
      return;
    }

    // Reorder the agenda items
    const reorderedAgenda = Array.from(agendaWithStartTimes);
    const [movedItem] = reorderedAgenda.splice(source.index, 1);
    reorderedAgenda.splice(destination.index, 0, movedItem);

    // Update positions in the backend
    for (let i = 0; i < reorderedAgenda.length; i++) {
      const updatedItem = reorderedAgenda[i];
      if (updatedItem.position !== i + 1) {
        // await agendaItemUpdate(updatedItem.agendaItemId, { position: i + 1 });
        await fetch(`${url}/agendaItem/${updatedItem.agendaItemId}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + authUser.token
          },
          body: JSON.stringify({
            position: i + 1,
          }),
        });

      }

    }
    // Recalculate start times
    const meetingTime = meeting.meetingDetails.meetingTime;
    const updatedAgendaWithStartTimes = calculateStartTime(meetingTime, reorderedAgenda);

    // Update the local state
    setAgendaWithStartTimes(updatedAgendaWithStartTimes);


    // Refresh the meeting data
    getMeeting();
  };

  return (
    <section className='agenda'>
      {
        isLoading ?
          <Spinner animation='border' variant='danger' />
          :
          <>
            {
              (meeting.items?.length === 0) ?
                <Row className='mt-3 mb-3'>
                  <Col>
                    <h2>There are no items in this agenda</h2>
                    {(authUser && authUser.user.acl === 'Officer') &&
                      <AgendaItemAddNewModal meetingId={meetingId} getMeeting={getMeeting} />
                    }
                  </Col>
                </Row>
                :
                <>
                  <Row className='mt-3 mb-3'>
                    <Col xs={12} xl={3}>
                      <Button variant={toggleColor} onClick={toggleWakeOnScreen}>{toggleText} {isNoSleep}</Button>
                    </Col>
                    <Col>
                      {/* <h4 className='float-end'>#{meeting.meetingDetails?.meetingNumber} - {meeting.meetingDetails?.meetingTheme}</h4> */}
                      <Button variant='dark' className='float-end' onClick={getMeeting}>
                        <i className='bi bi-arrow-clockwise'></i> Reload Agenda
                      </Button>
                    </Col>
                  </Row>
                  {(authUser && authUser.user.acl === 'Officer') &&
                    <Row className='mt-3 mb-3'>
                      <Col>
                        <AgendaItemAddNewModal meetingId={meetingId} getMeeting={getMeeting} />
                      </Col>
                    </Row>
                  }
                  <Row>
                    <Col>
                      <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="agenda">
                          {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                              {agendaWithStartTimes.map((agendaItem, index) => (
                                authUser && authUser.user.acl === 'Officer' ? (
                                  <Draggable key={agendaItem.agendaItemId} draggableId={agendaItem.agendaItemId} index={index}>
                                    {(provided) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <AgendaItemCard
                                          key={`card-${agendaItem.agendaItemId}`}
                                          agenda={agendaWithStartTimes}
                                          agendaItem={agendaItem}
                                          getMeeting={getMeeting}
                                        />
                                        <AgendaItemAddNewModal meetingId={meetingId} getMeeting={getMeeting} prevPos={agendaItem.position} />
                                      </div>
                                    )}
                                  </Draggable>
                                ) : (
                                  <div key={agendaItem.agendaItemId}>
                                    <AgendaItemCard
                                      key={`card-${agendaItem.agendaItemId}`}
                                      agenda={agendaWithStartTimes}
                                      agendaItem={agendaItem}
                                      getMeeting={getMeeting}
                                      startTime={agendaItem.startTime}
                                    />
                                  </div>
                                )
                              ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </Col>
                  </Row>
                </>
            }
          </>
      }
    </section>
  );
}